export function makeSearchParams(params = {}) {
  const { search, date, ownerId, schoolClassIds } = params;

  let searchParams = {};
  if (search) {
    searchParams['title'] = { $regex: search, $options: 'i' };
  }

  if (date) {
    searchParams['deadline'] = date;
  }

  if (ownerId) {
    searchParams['ownerId'] = ownerId;
  }

  if (schoolClassIds) {
    searchParams['schoolClassIds'] = {
      $in: schoolClassIds,
    };
  }

  return searchParams;
}

export const makeApprovedAtQuery = (option) => {
  switch (option) {
  case 'not-yet-approved':
    return {
      approvedAt: null,
    };
  case 'approved':
    return {
      approvedAt: { $ne: null },
    };
  }

  return {};
};

export const makeIsSelfStudyQuery = (option) => {
  switch (option) {
  case 'is-not-self-study':
    return {
      isSelfStudy: false,
    };
  case 'is-self-study':
    return {
      isSelfStudy: true,
    };
  }

  return {};
};

export const makeIsAssessmentQuery = (option) => {
  switch (option) {
  case 'is-not-assessment':
    return {
      isAssessment: false,
    };
  case 'is-assessment':
    return {
      isAssessment: true,
    };
  }

  return {};
};
